import React from 'react'
import { Button, Icon } from 'antd'
import { useTranslation } from 'react-i18next'

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  loading,
  direction = 'ltr'
}) => {
  const { t } = useTranslation()
  const isRTL = direction === 'rtl'
  const previousIcon = isRTL ? 'right' : 'left'
  const nextIcon = isRTL ? 'left' : 'right'

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 0',
        gap: '15px',
        direction
      }}
    >
      <Button
        style={{ borderRadius: '8px' }}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || loading}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <Icon type={previousIcon} />
          {t('v5:previous')}
        </span>
      </Button>
      <span style={{ color: '#000' }}>
        {`${t('general:page')} ${currentPage} of ${totalPages}`}
      </span>
      <Button
        style={{ borderRadius: '8px' }}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || loading}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          {t('buttons:next')}
          <Icon type={nextIcon} />
        </span>
      </Button>
    </div>
  )
}

export default CustomPagination
